// extracted by mini-css-extract-plugin
module.exports = {"Banner":"EcoBenefits_Banner__Fuc7d"};